/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './SubscriptionsCheckbox.scss';

import { bool, func, string } from 'prop-types';
import React from 'react';

import Checkbox from 'components/shared/Checkbox/Checkbox';

const SubscriptionsCheckbox = ({
  checked,
  name,
  onChange,
  partial,
  disabled
}) => (
  <div className="subscriptions-checkbox-wrapper">
    <Checkbox
      checked={checked}
      className="subscriptions-checkbox"
      dataTestId={`subscription-checkbox-${name}`}
      name={name}
      disabled={disabled}
      onChange={onChange}
      partial={partial}
    />
  </div>
);

SubscriptionsCheckbox.propTypes = {
  checked: bool.isRequired,
  name: string.isRequired,
  onChange: func.isRequired,
  partial: bool.isRequired
};

SubscriptionsCheckbox.defaultProps = {
  partial: false
};

export default SubscriptionsCheckbox;
